export default "__VITE_ASSET__DOGXNjTq__"